import React from 'react';

import { useTranslation } from 'react-i18next';

import Form from './Form';

import getOrdinal from '../../../helpers/getOrdinal';

export default function NumberPercentageArray({
  value,
  setFieldValue,
  name,
  values,
  errors,
  touched,
  setFieldTouched,
  setTouched,
  innerFields,
  achSchedule,
  readOnly,
}) {
  const { t } = useTranslation();

  if (readOnly && !value) {
    return null;
  }

  return (
    <div className="col-span-full flex flex-col gap-5">
      {value?.map?.((form, index) => (
        <Form
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          value={form}
          id={index}
          setFieldValue={setFieldValue}
          name={name}
          values={values}
          errors={errors[name]?.[index]}
          touched={touched}
          setFieldTouched={setFieldTouched}
          setTouched={setTouched}
          innerFields={innerFields}
          achSchedule={achSchedule}
          readOnly={readOnly}
        />
      ))}
      {!readOnly && (
        <button
          type="button"
          className="btn bg-indigo-500 hover:bg-indigo-600 text-white min-w-[180px] self-start flex justify-center"
          onClick={() => {
            setFieldValue(name, [
              ...(value || []),
              innerFields.reduce((acc, curr) => {
                return { ...acc, [curr.name]: curr.defaultValue ?? null };
              }, {}),
            ]);
          }}
        >
          <svg
            className="w-4 h-4 fill-current opacity-50 shrink-0"
            viewBox="0 0 16 16"
          >
            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
          </svg>
          <span className="ml-2">
            {t('Form.NumberPercentageArray.Add another payment')}
          </span>
        </button>
      )}

      {achSchedule && (
        <ul className="list-disc flex flex-col gap-2">
          <li>
            {t('Form.NumberPercentageArray.The payment is due on the')}{' '}
            {getOrdinal(values.due_day)} {t('Form.NumberPercentageArray.day')}.
          </li>
          <li>
            {t(
              'Form.NumberPercentageArray.If the scheduled day falls on a month with fewer days, the payment will be taken one day early. For example, a scheduled payment on the 31st day would be taken on September 30.'
            )}
          </li>
        </ul>
      )}
    </div>
  );
}
